export enum SubscriberIdType {
  MSISDN,
  ICCID,
  IMSI,
  OXIO_ID,
}
